import React, { memo } from 'react';
import { SvgUniqueID } from '@financial/svg-manager';

const IconLocation = /*#__PURE__*/memo(_ref => {
  let {
    fill = '#777',
    width = '100%',
    height = '100%',
    viewBox = '0 0 14 18',
    id,
    style = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(SvgUniqueID, {
    id: id
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: viewBox,
    style: style
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.982 9C5.85 9 4.93 8.084 4.93 6.955c0-1.13.92-2.046 2.053-2.046 1.134 0 2.053.916 2.053 2.046C9.035 8.084 8.115 9 6.982 9zm5.886 1.566c.714-1.103 1.092-2.377 1.092-3.684C13.96 3.09 10.828.002 6.98 0 3.134.002.002 3.089 0 6.882c0 1.303.377 2.577 1.113 3.714L6.98 18l5.888-7.434z",
    transform: "translate(-300 -401) translate(50 205) translate(20 181) translate(230 15)",
    fill: fill,
    fillRule: "evenodd"
  })));
});

export { IconLocation as default };
